import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { APP } from 'src/Configs/App'
import { api } from 'src/Services/api'

import { ErrorCode, NameSpace } from '../types'

interface CheckTrackBody {
  trackURL: string
}

interface CheckTrackResponse {
  errorMessage?: string
}

export const checkTrackToCreateCampaign = createAsyncThunk<
  CheckTrackResponse,
  CheckTrackBody
>(
  `${NameSpace.Campaign}/checkTrackToCreateCampaign`,
  async ({ trackURL }, { rejectWithValue }) => {
    try {
      const { data } = await api.post<CheckTrackResponse>(
        `${APP.TIKTOK_SERVER}/artist/spotify-campaigns/check-track`,
        {
          trackUrl: trackURL,
        },
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ errorMessage: string }>
      const status = response?.status || ErrorCode.InternalServerError
      const defaultText = response?.data?.errorMessage || 'something went wrong'
      const errorConflict =
        "You've already started a campaign for this track. To continue, either select a new track or check the campaign's details."
      return rejectWithValue({
        message: status === ErrorCode.Conflict ? errorConflict : defaultText,
        code: status,
      })
    }
  },
)
